<div class="page-container">
    <div class="page-header">
        <button type="button" class="btn-back" routerLink="/home/settings/report-predefind-data">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Expenses</span>
        </button>
        <div class="header-content">
            <h1 class="page-title">{{ isEdit === 'true' ? 'Edit' : 'Add New' }} Expense Item</h1>
            <p class="page-subtitle">{{ isEdit === 'true' ? 'Update' : 'Create' }} predefined expense information</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">{{ isEdit === 'true' ? 'Updating expense...' : 'Creating expense...' }}</p>
    </div>

    <div class="card" [class.loading]="isLoading">
        <div class="card-header">
            <div class="header-icon">
                <mat-icon>{{ isEdit === 'true' ? 'edit' : 'add_circle' }}</mat-icon>
            </div>
            <div class="header-text">
                <h2 class="card-title">Expense Details</h2>
                <p class="card-subtitle">Enter the expense information below</p>
            </div>
        </div>

        <div class="card-body">
            <form class="expense-form">
                <div class="form-section">
                    <h3 class="section-title">Basic Information</h3>

                    <div class="form-row">
                        <mat-form-field class="form-field" appearance="outline">
                            <mat-label>Expense Account</mat-label>
                            <input matInput [(ngModel)]="expenseAccount" name="expenseAccount" />
                            <mat-icon matPrefix>account_balance</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="form-field" appearance="outline">
                            <mat-label>Expense Class</mat-label>
                            <input matInput [(ngModel)]="expenseClass" name="expenseClass" />
                            <mat-icon matPrefix>category</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="form-field" appearance="outline">
                            <mat-label>Line Class</mat-label>
                            <input matInput [(ngModel)]="lineClass" name="lineClass" />
                            <mat-icon matPrefix>label</mat-icon>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-section">
                    <h3 class="section-title">Expense Details</h3>

                    <div class="form-row">
                        <mat-form-field class="form-field" appearance="outline">
                            <mat-label>Expense Amount</mat-label>
                            <input matInput type="number" [(ngModel)]="expenseAmount" name="expenseAmount" />
                            <mat-icon matPrefix>attach_money</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="form-field" appearance="outline">
                            <mat-label>Expense Description</mat-label>
                            <input matInput [(ngModel)]="expenseDesc" name="expenseDesc" />
                            <mat-icon matPrefix>description</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="form-field" appearance="outline">
                            <mat-label>Expense Billable Entity</mat-label>
                            <input matInput [(ngModel)]="expenseBillableEntity" name="expenseBillableEntity" />
                            <mat-icon matPrefix>business</mat-icon>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-section">
                    <h3 class="section-title">Settings</h3>

                    <div class="radio-group">
                        <label class="radio-label">Is Amount Editable?</label>
                        <mat-radio-group [(ngModel)]="isAmountEditable" name="isAmountEditable" class="radio-options">
                            <mat-radio-button *ngFor="let option of editOption" [value]="option" class="radio-option">
                                {{ option }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-actions">
                    <button type="button" class="btn-cancel" routerLink="/home/settings/report-predefind-data">
                        <mat-icon>close</mat-icon>
                        <span>Cancel</span>
                    </button>
                    <button type="submit" class="btn-submit" (click)="submitButtonAction()">
                        <mat-icon>{{ isEdit === 'true' ? 'save' : 'add' }}</mat-icon>
                        <span>{{ isEdit === 'true' ? 'Update' : 'Create' }} Expense</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
